import { get, set } from 'idb-keyval';

class DBService{
    async store(key, data)  {
        return await set(key, data);
    }
    async find(key) {
        return get(key);
    }

}

export default new DBService();